import { configureStore } from "@reduxjs/toolkit";
// Import your slices here
import productsSlice from "./slices/productsSlice";
import authSlice from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    // Add your slice reducers here
    products: productsSlice,
    auth: authSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serializable check
        ignoredActions: [],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
});

